// Cài `gh` CLI qua package manager đã detect. Stream stdio để user thấy progress.
// Throws nếu cài fail hoặc PM trả non-zero.
import { spawnSync } from "node:child_process";
import type { PackageManager } from "./detect-package-manager.js";
import { log } from "./terminal-logger.js";

// Map PM → command + args để cài gh. apt/dnf cần sudo; brew/pacman/winget thì không.
const INSTALL_COMMANDS: Record<PackageManager, { cmd: string; args: string[] }> = {
  brew: { cmd: "brew", args: ["install", "gh"] },
  apt: { cmd: "sudo", args: ["apt-get", "install", "-y", "gh"] },
  dnf: { cmd: "sudo", args: ["dnf", "install", "-y", "gh"] },
  pacman: { cmd: "sudo", args: ["pacman", "-S", "--noconfirm", "github-cli"] },
  winget: { cmd: "winget", args: ["install", "--id", "GitHub.cli", "-e", "--silent"] },
};

export function installGhCliViaPackageManager(pm: PackageManager): void {
  const spec = INSTALL_COMMANDS[pm];
  log.info(`Đang cài gh CLI qua ${pm}...`);
  const r = spawnSync(spec.cmd, spec.args, { stdio: "inherit" });
  if (r.status !== 0) {
    throw new Error(`Cài gh CLI thất bại qua ${pm} (exit ${r.status}). Cài tay rồi chạy lại.`);
  }
  log.success("Đã cài gh CLI");
}
